export default __webpack_public_path__ + "static/media/partners-logo-transys-w@3x.e2ff033e.webp";